import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { Alert } from 'reactstrap';
import { Query } from 'react-apollo';
import Spinner from '~/components/spinner/spinner';
import UpcomingLotsGraph from '~/components/upcomingLotsGraph/upcomingLotsGraph';

export const getUpcomingLotsQuery = gql`
  query lost($breweryId: Int!, $vesselTransferDateBefore: String, $vesselTransferDateAfter: String) {
    lots(
      breweryId: $breweryId
      vesselTransferDateBefore: $vesselTransferDateBefore
      vesselTransferDateAfter: $vesselTransferDateAfter
      status: "IN_PROGRESS"
    ) {
      id
      volume
      transfers {
        id
        transferDate
        type
      }
    }
  }
`;

const massageLotData = lots =>
  lots.map(l => {
    try {
      return {
        ...l,
        vesselTransferDate: l.transfers.filter(t => t.type === 'VESSEL')[0].transferDate
      };
    } catch (err) {
      console.error('Error massaging data for vessel transfer date', err);
      return [];
    }
  });

const AllUpcomingLotsGraph = ({ brewery }) => {
  const after = moment()
    .startOf('week')
    .format('YYYY-MM-DD');
  const before = moment()
    .endOf('week')
    .format('YYYY-MM-DD');
  return (
    <Query
      query={getUpcomingLotsQuery}
      variables={{ breweryId: brewery.id, vesselTransferDateBefore: before, vesselTransferDateAfter: after }}
      fetchPolicy={'cache-and-network'}
    >
      {props => {
        const { loading, error, data } = props;
        if (loading) {
          return <Spinner className="absolute absolute-center stroke-brand-red" />;
        }

        if (error) {
          return <Alert color="danger">Sorry, there was an error getting the upcoming lot details</Alert>;
        }

        const { lots } = data;

        return (
          <div className="content">
            <UpcomingLotsGraph lots={massageLotData(lots)} />
          </div>
        );
      }}
    </Query>
  );
};

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}
export default connect(mapStateToProps)(AllUpcomingLotsGraph);



// WEBPACK FOOTER //
// ./src/containers/allUpcomingLotsGraph/allUpcomingLotsGraph.jsx